import React, { useEffect } from 'react'
import { useNetdaniaData } from './useNetdaniaData'
import { Item } from './Item'

const $ = jQuery

export default function Items(props) {
  const instruments = props.data
  const [value, requests] = useNetdaniaData(instruments, 400)
  useEffect(() => {
    const CARDS = document.querySelector(
      '.mtt-ttmzero-cover__items-inner--skeleton-loader'
    )
    $(CARDS).addClass('mtt-ttmzero-cover__items-inner--hidden')
  }, [])
  return (
    <div className="mtt-ttmzero-cover__items-inner">
      {requests.map(({ i, s }) => {
        if (value?.[i] == null) {
          return null
        }
        return <Item v={value[i]} key={i} i={i} symbol={s} />
      })}
    </div>
  )
}
